import {
  DECODE_ZIP,
  DECODE_ZIP_SUCCESS,
  DECODE_VIN,
  DECODE_VIN_SUCCESS,
  SUBMIT_FEES_FORM,
  SUBMIT_FEES_SUCCESS,
  SUBMIT_FEES_FAILED,
  SAVE_FEES_FORM_DATA,
  CLEAR_FEES_ERROR,
  CLEAR_FEES_RESPONSE
} from './types';

const INITIAL_STATE = {
  cities: [],
  states: [],
  countries: [],
  vinData: {
    bodyStyle: '',
    cylinders: '',
    fuel_type: '',
    gvw: '',
    make: '',
    model: '',
    model_year: '',
    mpg: null,
    msrp: '',
    source: '',
    vehicle_type: '',
    weight: '',
  },
  formData: {},
  isLoading: false,
  response: {},
  feesError: null,
};

const feesReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case DECODE_ZIP:
      return { ...state };

    case DECODE_ZIP_SUCCESS:
      return {
        ...state,
        cities: payload.cities || [],
        states: payload.states || [],
        countries: payload.counties || [],
      };

    case DECODE_VIN:
      return { ...state };

    case DECODE_VIN_SUCCESS:
      return {
        ...state,
        vinData: payload,
      };

    case SUBMIT_FEES_FORM:
      return {
        ...state,
        isLoading: true,
        feeInfo: payload,
      };

    case SUBMIT_FEES_SUCCESS:
      return {
        ...state,
        response: payload,
        isLoading: false,
      };

    case SUBMIT_FEES_FAILED:
      return {
        ...state,
        isLoading: false,
        feesError: payload.error,
      };

    case SAVE_FEES_FORM_DATA:
      return {
        ...state,
        formData: payload
      };

    case CLEAR_FEES_ERROR:
      return {
        ...state,
        feesError: null,
      };

    case CLEAR_FEES_RESPONSE:
      return {
        ...state,
        response: {},
      };

    default:
      return state;
  }
};

export default feesReducer;
